"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NolNotificationListDataSchema = exports.NolNotificationListItemDataSchema = exports.NolNotificationBadgeType = void 0;
var zod_1 = require("zod");
exports.NolNotificationBadgeType = {
    NOTICE: 'NOTICE',
    DRAW_RESULT: 'DRAW_RESULT',
};
exports.NolNotificationListItemDataSchema = zod_1.z.object({
    title: zod_1.z.string(),
    badge: zod_1.z.object({ type: zod_1.z.nativeEnum(exports.NolNotificationBadgeType), name: zod_1.z.string() }),
    action: zod_1.z.object({ app: zod_1.z.string(), web: zod_1.z.string() }),
    logMeta: zod_1.z.object({
        object: zod_1.z.string(),
        noticeBannerTitle: zod_1.z.string(),
        deepLinkUri: zod_1.z.string(),
        position: zod_1.z.number(),
        noticeBannerId: zod_1.z.string(),
    }),
});
exports.NolNotificationListDataSchema = zod_1.z.object({
    header: zod_1.z.object({ title: zod_1.z.string() }).nullish(),
    items: zod_1.z.array(exports.NolNotificationListItemDataSchema),
    logMeta: zod_1.z.object({
        objectContainer: zod_1.z.string(),
        widgetTitle: zod_1.z.string(),
        widgetPosition: zod_1.z.number(),
    }),
});
